import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  MDBRow,
  MDBCol,
  MDBCardBody,
  MDBBadge,
  MDBRadio,
  MDBCard,
  MDBSpinner,
} from "mdb-react-ui-kit";

function CommitteeMembers({ members, committeeCode }) {
  const [legislators, setLegislators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [partyFilter, setPartyFilter] = useState("all");

  // hard-coded members for certain committees:
  const hardcodedMap = {
    CJOC: [
      {
        legislatorId: null,
        firstName: "Jimmy",
        lastName: "Patelis",
        title: "Member",
        organization: "Board of Pardons and Parole",
        type: { name: "Vice Chair" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        designation: "Hon.",
        firstName: "Luke",
        lastName: "Berger",
        title: "District Court Judge",
        organization: "District Court",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        designation: "Hon.",
        firstName: "Mark",
        lastName: "Dunn",
        title: "Municipal Court Judge",
        organization: "Municipal Court",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Alan",
        lastName: "Doane",
        title: "Attorney General's Designee",
        organization: "Office of the Attorney General",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Brian",
        lastName: "Gootkin",
        title: "Director",
        organization: "Department of Corrections",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Brett",
        lastName: "Schandelson",
        title: "Director",
        organization: "Office of State Public Defender",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Charlie",
        lastName: "Brereton",
        title: "Director",
        organization: "Department of Public Health and Human Services",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Ross",
        lastName: "Canen",
        title: "Sheriff",
        organization: "County Sheriff's Office",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Scott",
        lastName: "Twito",
        title: "County Attorney",
        organization: "County Attorney's Office",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Eldena",
        lastName: "Bear Don't Walk",
        title: "Tribal Member with Criminal Justice Expertise",
        organization: "Federally Recognized Indian Tribe",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Shantelle",
        lastName: "Gaynor",
        title: "Representative of Crime Victims",
        organization: "Board of Crime Control",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Henry",
        lastName: "Seaton",
        title: "Representative of Civil Rights Advocates",
        organization: "Civil Rights Advocates",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Melissa",
        lastName: "Kelly",
        title: "Representative of Community Corrections Facilities",
        organization: "Community Corrections Facilities",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Amy",
        lastName: "Tenney",
        title: "Representative of Community Corrections Facilities",
        organization: "Community Corrections Facilities",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
    TRC: [
      {
        legislatorId: 31,
        designation: "Sen.",
        firstName: "Christopher",
        lastName: "Pope",
        chamber: "SENATE",
        type: { name: "Vice Chair" },
        politicalParty: { code: "D" },
      },
      {
        legislatorId: 90,
        designation: "Sen.",
        firstName: "Dennis",
        lastName: "Lenz",
        chamber: "SENATE",
        type: { name: "Member" },
        politicalParty: { code: "R" },
      },
      {
        legislatorId: 10,
        designation: "Sen.",
        firstName: "Mary",
        lastName: "Caferro",
        chamber: "HOUSE",
        type: { name: "Member" },
        politicalParty: { code: "D" },
      },
      {
        legislatorId: null,
        firstName: "Jennifer",
        lastName: "Carlson",
        title: "Former Legislator",
        organization: "",
        chamber: "",
        type: { name: "Chair" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Heather",
        lastName: "O'Hara",
        title: "Vice President",
        organization: "Montana Hospital Association",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Mike",
        lastName: "Lahr",
        title: "Attorney",
        organization: "Disability Rights Montana",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Melanie",
        lastName: "Williams",
        title: "Program Director",
        organization: "Montana Alzheimer’s Association",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Ann",
        lastName: "Geiger",
        title: "Executive Director",
        organization: "Liberty Place",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        designation: "Dr.",
        firstName: "Reza",
        lastName: "Ghomi",
        title: "Co-Founder",
        organization: "Frontier Psychiatry",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Sara",
        lastName: "Hansen-Baiamonte",
        title: "Family Member/Guardian",
        organization: "Self-advocate for Montana State Hospital patients",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Shawna",
        lastName: "Karjala",
        title: "Medicaid Complex Care Coordinator",
        organization: "Montana Department of Public Health and Human Services",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
    ITPC: [
      {
        legislatorId: null,
        firstName: "Jerry",
        lastName: "Howe",
        title: "Legislative Services Director",
        organization: "Legislative Services Division",
        chamber: "",
        type: { name: "Chair" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Kevin",
        lastName: "Gilbertson",
        title: "State Chief Information Officer",
        organization: "State Information Technology Services Division",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Marissa",
        lastName: "Stockton",
        title: "Secretary of Senate",
        organization: "Montana Senate",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Carolyn",
        lastName: "Tschida",
        title: "Chief Clerk of the House",
        organization: "Montana House of Representatives",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Angus",
        lastName: "Maciver",
        title: "Legislative Auditor",
        organization: "Legislative Audit Division",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Amy",
        lastName: "Carlson",
        title: "Lead Fiscal Analyst",
        organization: "Legislative Fiscal Division",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Dale",
        lastName: "Gow",
        title: "Chief Information Officer",
        organization: "Legislative Services Division",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
    EQC: [
      {
        legislatorId: null,
        firstName: "Jim",
        lastName: "Keane",
        title: "Former Legislator",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Jon",
        lastName: "Metropoulos",
        title: "Attorney",
        organization: "Metropoulos/Nerison/Associates",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Mike",
        lastName: "Mershon",
        title: "Director & President-Elect",
        organization: "Montana Wildlife Federation",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Brian",
        lastName: "Yablonski",
        title: "Chief Executive Officer",
        organization: "Property and Environment Research Center (PERC)",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
    SFIC: [
      {
        legislatorId: null,
        firstName: "Martha",
        lastName: "Potter",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Mike",
        lastName: "Waterman",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Matt",
        lastName: "Schreiber",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Tom",
        lastName: "Burnett",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Tim",
        lastName: "Tharp",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Susie",
        lastName: "Hedalen",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Clayton",
        lastName: "Christian",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Rachel",
        lastName: "Green",
        title: "",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
    MARA: [
      {
        legislatorId: null,
        firstName: "Heather",
        lastName: "O'Loughlin",
        title: "Executive Director",
        organization: "Montana Budget and Policy Center",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Jim",
        lastName: "Hamilton",
        title: "Former Legislator",
        organization: "",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Jesse",
        lastName: "Ramos",
        title: "State Director",
        organization: "Americans for Prosperity",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
      {
        legislatorId: null,
        firstName: "Kendall",
        lastName: "Cotton",
        title: "President and CEO",
        organization: "Frontier Institute",
        chamber: "",
        type: { name: "Member" },
        politicalParty: { code: null },
      },
    ],
  };

  // define who is ex-officio on which committee
  const exOfficioByCommittee = {
    LFC: [
      //"Albus",
      //"Keogh",
      //"Jones",
      //"Barker",
      //"Muszkiewicz",
      //"Tuss",
      "Falk",
      "Gillette",
      "Schillinger",
      "Nave",
      "Bedey",
      "Fitzpatrick",
    ],
  };

  // new array to render both hard coded and normal members:
  const overrideMembers = hardcodedMap[committeeCode] || [];
  let effectiveMembers =
    committeeCode === "TRC"
      ? overrideMembers
      : [...(members || []), ...overrideMembers];

  useEffect(() => {
    const fetchLegislators = async () => {
      const legislatorIds = (effectiveMembers || [])
        .map((m) => m.legislatorId)
        .filter((id) => id != null);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=100&offset=0`,
          { legislatorIds }
        );
        const fetchedLegislators = response.data.content || [];

        const electedLegislators = fetchedLegislators.filter(
          (leg) => leg.electionStatus !== null
        );

        const emailAddresses = electedLegislators.map(
          (legislator) => legislator.emailAddress
        );
        if (emailAddresses.length > 0) {
          const wpprofileResponse = await axios.post(
            `${process.env.REACT_APP_WP_HOST}/wp-json/legmt/v1/legislators/findByEmails`,
            { emails: emailAddresses.filter((email) => email !== null) }
          );

          const wpprofileData = wpprofileResponse.data;

          const legislatorsWithWPDate = electedLegislators.map((legislator) => {
            const wpprofile = wpprofileData.find(
              (profile) => profile.emailAddress === legislator.emailAddress
            );
            return {
              ...legislator,
              profilePictureUrl: wpprofile?.photo?.url || null,
              profileUrl: wpprofile?.links?.profileUrl || null,
            };
          });

          setLegislators(legislatorsWithWPDate);
        }
      } catch (error) {
        console.error("Error fetching legislator details or WP Data:", error);
      } finally {
        setLoading(false); // Stop loading when data is fetched
      }
    };

    fetchLegislators();
  }, [members]);

  // const combinedMembers = effectiveMembers.map((member) => {
  //   const leg = legislators.find((l) => l.id === member.legislatorId) || {};
  //   return { ...member, ...leg };
  // });

  const filteredMembers = (effectiveMembers || [])
    .map((member) => {
      const leg = legislators.find((l) => l.id === member.legislatorId) || {};
      return { ...member, ...leg };
    })
    .filter((member) => {
      if (partyFilter === "all") return true;
      return member.politicalParty?.code === partyFilter;
    });

  // partition into two groups
  const typeOrder = { Chair: 0, "Vice Chair": 1, Member: 2 };

  const legislatorsList = filteredMembers
    .filter((m) => m.legislatorId != null)
    .sort((a, b) => {
      const ta = typeOrder[a.type?.name] ?? 3;
      const tb = typeOrder[b.type?.name] ?? 3;
      if (ta !== tb) return ta - tb;
      return (a.lastName ?? "").localeCompare(b.lastName ?? "", undefined, {
        sensitivity: "base",
      });
    });
  const publicMembersList = filteredMembers
    .filter((m) => m.legislatorId == null)
    .sort((a, b) =>
      (a.lastName ?? "").localeCompare(b.lastName ?? "", undefined, {
        sensitivity: "base",
      })
    );

  return (
    <>
      <MDBRow className="mb-3">
        <MDBCol>
          <h5 className="sub-heading">Legislator Members</h5>
        </MDBCol>
        <MDBCol size="auto">
          <div className="d-flex justify-content-end badge-filter">
            <MDBRadio
              name="inlineRadio"
              value="all"
              label={<span className="badge">All</span>}
              inline
              defaultChecked
              onChange={() => setPartyFilter("all")}
            />
            <MDBRadio
              name="inlineRadio"
              value="D"
              label={<span className="badge bg-custom7">Democrat (D)</span>}
              inline
              onChange={() => setPartyFilter("D")}
            />
            <MDBRadio
              name="inlineRadio"
              value="R"
              label={<span className="badge bg-custom6">Republican (R)</span>}
              inline
              onChange={() => setPartyFilter("R")}
            />
          </div>
        </MDBCol>
      </MDBRow>
      <MDBRow id="members" className="g-2">
        {loading ? (
          <div className="d-flex justify-content-center mt-5">
            <MDBSpinner role="status">
              <span className="visually-hidden">Loading...</span>
            </MDBSpinner>
          </div>
        ) : (
          <>
            {legislatorsList.length > 0 && (
              <>
                <MDBRow className="g-2 mb-4">
                  {legislatorsList.map((member, idx, arr) => {
                    // insert a divider once, when we hit the first "Member" after Chairs/Vice
                    const prevType = arr[idx - 1]?.type?.name;
                    const isDivider =
                      idx > 0 &&
                      prevType !== "Member" &&
                      member.type?.name === "Member";

                    const imageUrl = member.profilePictureUrl || null;
                    const profileUrl = member.profileUrl || "#";

                    return (
                      <React.Fragment key={`leg-${idx}`}>
                        {isDivider && <hr className="mt-4" />}
                        <MDBCol xl={4} md={6}>
                          <a
                            href={profileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <MDBCard className="profile rounded-0 border-0 bg-transparent shadow-none">
                              <MDBCardBody>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center">
                                    {member.legislatorId && (
                                      <div className="portrait rounded-circle d-flex align-items-center justify-content-center text-white text-center">
                                        {imageUrl ? (
                                          <img
                                            src={imageUrl}
                                            alt={`${member.firstName} ${member.lastName} Portrait`}
                                            className="d-block"
                                          />
                                        ) : (
                                          <div>
                                            No <br /> Photo
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    <div className="ms-3">
                                      {(member.chamber ||
                                        member.politicalParty?.code) && (
                                        <h6 className="sub-heading text-muted m-0 d-flex align-items-center">
                                          {member.chamber === "SENATE"
                                            ? "Senator"
                                            : member.chamber === "HOUSE"
                                            ? "Representative"
                                            : ""}
                                          <MDBBadge
                                            className="ms-2"
                                            pill
                                            color={
                                              member.politicalParty?.code ===
                                              "R"
                                                ? "custom6"
                                                : "custom7"
                                            }
                                          >
                                            (
                                            {member.politicalParty?.code ||
                                              "N/A"}
                                            )
                                          </MDBBadge>
                                        </h6>
                                      )}
                                      <h5 className="mb-0">
                                        {member.designation
                                          ? member.designation + " "
                                          : ""}
                                        {member.lastName}, {member.firstName}
                                      </h5>
                                      <h6 className="text-body member-type mb-0">
                                        {member.type.name}
                                        {exOfficioByCommittee[
                                          committeeCode
                                        ]?.includes(member.lastName) &&
                                          " (Ex-Officio)"}
                                      </h6>
                                      {member.title && (
                                        <p className="small text-muted member-title mb-1">
                                          {member.title}
                                        </p>
                                      )}
                                      {member.organization && (
                                        <p className="small text-muted member-organization mb-2">
                                          {member.organization}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </MDBCardBody>
                            </MDBCard>
                          </a>
                        </MDBCol>
                      </React.Fragment>
                    );
                  })}
                </MDBRow>
              </>
            )}

            {publicMembersList.length > 0 && (
              <>
                <h5 className="sub-heading">Non-Legislator Members</h5>
                <MDBRow className="g-2">
                  {publicMembersList.map((member, idx) => {
                    const imageUrl = member.profilePictureUrl || null;
                    const profileUrl = member.profileUrl || "#";
                    return (
                      <MDBCol xl={4} md={6} key={`pub-${idx}`}>
                        <a
                          href={profileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <MDBCard className="profile rounded-0 border-0 bg-transparent shadow-none">
                            <MDBCardBody>
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                  {/* public members have no portrait */}
                                  <div className="ms-3">
                                    <h5 className="mb-0">
                                      {member.designation
                                        ? member.designation + " "
                                        : ""}
                                      {member.lastName}, {member.firstName}
                                    </h5>
                                    <h6 className="text-body member-type mb-0">
                                      {member.type.name}
                                      {exOfficioByCommittee[
                                        committeeCode
                                      ]?.includes(member.lastName) &&
                                        " (Ex-Officio)"}
                                    </h6>
                                    {member.title && (
                                      <p className="small text-muted member-title mb-1">
                                        {member.title}
                                      </p>
                                    )}
                                    {member.organization && (
                                      <p className="small text-muted member-organization mb-2">
                                        {member.organization}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </MDBCardBody>
                          </MDBCard>
                        </a>
                      </MDBCol>
                    );
                  })}
                </MDBRow>
              </>
            )}

            {legislatorsList.length === 0 && publicMembersList.length === 0 && (
              <p className="small text-center mt-5">
                No members found for this party.
              </p>
            )}
          </>
        )}
      </MDBRow>
    </>
  );
}

export default CommitteeMembers;
